import PropTypes from 'prop-types'
import { requiredIf } from '../utility/prop-types-helper'

export const PER_PAGE = 10

export const DUAL_PANEL_SELECTABLE_TYPES = {
  students: 'students',
  programs: 'programs',
  programsWithPackages: 'programsWithPackages',
  programsWithAnnouncement: 'programsWithAnnouncement',
  series: 'series',
  coaches: 'coaches',
}

export const ItemCardProps = {
  item: PropTypes.object.isRequired,
  isSelectable: PropTypes.bool,
  isChecked: requiredIf(PropTypes.bool, ({ isSelectable }) => isSelectable),
  onCheckChange: requiredIf(PropTypes.func, ({ isSelectable }) => isSelectable),
  withAdditionalSelect: PropTypes.bool,
  onSelect: requiredIf(PropTypes.func, ({ withAdditionalSelect }) => withAdditionalSelect),
  onSelectDelete: requiredIf(PropTypes.func, ({ withAdditionalSelect }) => withAdditionalSelect),
  className: PropTypes.string,
  hasNewCategory: PropTypes.bool,
}
